import React from "react";
import AlgorithmGraph from "../components/AlgorithmGraph";
import animations from "../util/animations";
import theme from "../theme";
import { f, df, x, y } from "../util/function";
const colors = theme.screen.colors.extra;

export default class extends React.Component {
  state = {
    x0: this.props.x0
  };
  static defaultProps = {
    repeat: false,
    color: false,
    frames: [],
    wait: [],
    points: [],
    animate: true
  };
  frameIndex = 0;
  zeroCache = {};

  addAnimations() {
    const { frames } = this.props;
    const i = this.frameIndex % frames.length;
    ++this.frameIndex;
    if (!this.props.repeat && this.frameIndex >= frames.length) return;
    const j = this.frameIndex % frames.length;
    animations.add(this, {
      min: frames[i],
      max: frames[j],
      length: this.props.wait[i] || 1000,
      key: "x0",
      ease: animations.easing.cubic,
      onEnd: () => this.addAnimations()
    });
  }

  componentDidMount() {
    if (this.props.animate) this.addAnimations();
    this.zeroCache = {};
  }

  componentWillUnmount() {
    animations.remove(this);
  }

  findZero(x) {
    x = Math.round(1000 * x) / 1000;
    const k = "" + x;
    if (this.zeroCache[k]) return this.zeroCache[k];
    const findClosest = ([a], [b]) => Math.abs(a - x) - Math.abs(b - x);
    let fx = f(x);
    for (let i = 0; i < 20; ++i) {
      x -= fx / df(x);
      fx = f(x);
      if (Math.abs(fx) < 1e-2) {
        return (this.zeroCache[k] = [
          [-1, colors[1]],
          [0, colors[3]],
          [1, colors[4]]
        ].sort(findClosest)[0][1]);
      }
    }
    return (this.zeroCache[k] = "#000000");
  }

  render() {
    const color = this.props.color ? this.findZero(this.state.x0) : colors[1];
    const points = this.props.points.map(x => {
      return { color: this.findZero(x), step: 0, x };
    });
    if (this.props.animate) {
      for (let i = 0; i < 4; ++i) {
        let x = this.state.x0;
        if (i > 0) {
          x = points[points.length - 1].x;
          x -= f(x) / df(x);
        }
        points.push({
          x,
          length: 1.1 * Math.abs(f(x) / df(x)),
          step: i === 3 ? 0 : 2,
          color
        });
      }
    }
    return (
      <AlgorithmGraph
        evalCount={60}
        f={f}
        df={df}
        x={x}
        y={y}
        points={points}
      />
    );
  }
}
